import { Theme } from '@mui/material/styles';

export default function Button({ palette }: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        contained: {
          background: palette.primary.main,
          color: palette.text.primary,
        },
        text: {
          color: palette.text.primary,
          '&:hover, &.active': {
            color: palette.text.primary,
            opacity: 1,
            backgroundColor: 'rgba(256,256,256, .2)',
          },
        },
        sizeLarge: {
          height: 56,
        },
      },
    },
  };
}
